// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"e2286d16","343":"3a7f47a3","477":"46dc4e95","491":"5efe8227","775":"c43f6803","787":"fdc81086","850":"8634b81c","972":"799d350b"}[chunkId] + ".chunk.js";
};